import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'

import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => ({
  ...filter,
  includedUserTags: [insights.map((i) => i.searchName)]
})

const generateIncludeUserTagsStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateIncludeUserTagsStrategy
